import { Box, Flex } from "@chakra-ui/react";
import CreatorNavLeft from "@/components/creatorcenter/creatorLeft";
import { Outlet } from "react-router-dom";

const CreatorCenter = () => {

  return (
    <Flex
      h="calc(100vh - 61px)"
      p="20px"
      boxSizing="border-box"
      flexDir={"column"}
    >
      <Box
        mt="20px"
        mb="20px"
        color="#27314D"
        fontWeight="bold"
        fontSize="24px"
      >
        创作者中心
      </Box>
      <Flex h="0" flex={1}>
        <Box h="100%" pr="15px" borderRight={"1px solid #DCE0EB"}>
          <CreatorNavLeft />
        </Box>
        <Box h="100%" flex={1} w="0">
          <Outlet />
        </Box>
      </Flex>
    </Flex>
  );
};

export default CreatorCenter;
